/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Openquestionsansweredit3Inputs */

const en_openquestionsansweredit3 = /** @type {(inputs: Openquestionsansweredit3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`edit`)
};

const pt_openquestionsansweredit3 = /** @type {(inputs: Openquestionsansweredit3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`editar`)
};

/**
* | output |
* | --- |
* | "edit" |
*
* @param {Openquestionsansweredit3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const openquestionsansweredit3 = /** @type {((inputs?: Openquestionsansweredit3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Openquestionsansweredit3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_openquestionsansweredit3(inputs)
	return pt_openquestionsansweredit3(inputs)
});
export { openquestionsansweredit3 as "openQuestionsAnswerEdit" }